import { useEffect, useState, useMemo, type ReactNode } from "react";
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { RoutePath } from '@/section/router';

export function ManageCustomersPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === RoutePath.ManageCustomers) {
      navigate(RoutePath.CrmList, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className="flex flex-col gap-4 overflow-hidden max-w-full h-full">
      Loading CRM...
    </div>
  );
}
